/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactItemDto } from './subjectContactItemDto.model';


export interface BulkActionContractDto { 
    contractNumberOfficial?: string;
    counterpartyNumber?: string;
    id?: number;
    owners?: Array<SubjectContactItemDto>;
    tenants?: Array<SubjectContactItemDto>;
}

